import { deserialize, serializable } from 'serializr';

export class FilterDropdown {
  @serializable
  public id: number;

  @serializable
  public name: string;

  deserialize(input: any): this {
    return Object.assign(this, deserialize(FilterDropdown, input));
  }
}
